import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { productBrandStyles } from "@insite/content-library/Components/ProductBrand";
import { css } from "styled-components";

productBrandStyles.nameText = mergeToNew(productBrandStyles.nameText, {
    size: "14px",
    weight: 400,
    lineHeight: "20px",
});

productBrandStyles.nameLink = mergeToNew(productBrandStyles.nameLink, {
    css: css`
        width: 100%;
    `,
    typographyProps: productBrandStyles.nameText,
});
